export const generateTelemetryKey = (prefix) => (key) => `${prefix}.${key}`;
//# sourceMappingURL=generateTelemetryKey.js.map